import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { FaTaxi, FaBars, FaTimes, FaPhoneAlt, FaUser, FaSearch, FaUserCircle, FaCaretDown } from 'react-icons/fa';
import "./navbar.css";
import { auth } from '../../Components/FirebaseComp/firebase';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faFile, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';

function NavComp() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setIsLoggedIn(!!user);
    });
    return () => unsubscribe();
  }, []);

  const handleLogout = async () => {
    try {
      await auth.signOut();
      setIsLoggedIn(false);
      navigate('/');
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };

  const handleDropdownClick = (event) => {
    if (dropdownRef.current && dropdownRef.current.contains(event.target)) {
      setShowDropdown(false);
    }
  };

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const toggleDropdown = (dropdownName) => {
    setActiveDropdown((prev) => (prev === dropdownName ? null : dropdownName));
  };

  const closeAllMenus = () => {
    setIsMenuOpen(false);
    setActiveDropdown(null);
    setShowDropdown(false);
  };



  // Separate handler for profile dropdown
const toggleProfileDropdown = () => {
  setShowDropdown((prev) => !prev);
};

// Close dropdown if clicking outside
useEffect(() => {
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setShowDropdown(false);
    }
  };
  document.addEventListener("mousedown", handleClickOutside);
  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, []);






  return (
    <nav className="chavo-navbar">
      
      <div className="chavo-navbar-container">
        <div className="chavo-logo">
          <Link to="/" onClick={closeAllMenus}>
            <img src="/logo.jpg" alt="Chavo Tours Logo" className="chavo-logo-img" />
          </Link>
          <Link to="/" onClick={closeAllMenus}>
            <h1 className="chavo-nav-logo-text">CHAVO TOURS</h1>
          </Link>
        </div>

        {/* Mobile Menu Toggle Button */}
        <button className="menu-toggle" onClick={toggleMenu}>
          {isMenuOpen ? '✕' : '☰'}
        </button>

<ul className={`chavo-navbar-links ${isMenuOpen ? "open" : ""}`}>
  <li><Link to="/" className="chavo-navbar-link" onClick={closeAllMenus}>Home</Link></li>
  <li><Link to="/booking" className="chavo-navbar-link" onClick={closeAllMenus}>Bookings</Link></li>

  <li className={`dropdown ${activeDropdown === 'thingsToDo' ? 'active' : ''}`}>
    <a
      href="#!"
      className="chavo-navbar-link"
      onClick={(e) => {
        e.preventDefault();
        toggleDropdown('thingsToDo');
      }}
    >
      Things to Do
      <span className="dropdown-arrow">&#9660;</span>
    </a>
    <ul className="dropdown-menu">
      <li><Link to="/wildlife" onClick={closeAllMenus}>Wildlife & Safari</Link></li>
      <li><Link to="/rafting" onClick={closeAllMenus}>Rafting</Link></li>
      <li><Link to="/surfing" onClick={closeAllMenus}>Surfing</Link></li>
      <li><Link to="/mountain-and-hiking" onClick={closeAllMenus}>Mountains & Hiking</Link></li>
      <li><Link to="/bird-watching" onClick={closeAllMenus}>Bird Watching</Link></li>
      <li><Link to="/boat-safari" onClick={closeAllMenus}>Boat Safari</Link></li>
      <li><Link to="/jet-skiing" onClick={closeAllMenus}>Jet Skiing</Link></li>
      <li><Link to="/balloon-rides" onClick={closeAllMenus}>Balloon Rides</Link></li>
    </ul>
  </li>

  <li><Link to="/gallery" className="chavo-navbar-link" onClick={closeAllMenus}>Gallery</Link></li>
  <li><Link to="/aboutus" className="chavo-navbar-link" onClick={closeAllMenus}>About Us</Link></li>
  <li><Link to="/contactus" className="chavo-navbar-link" onClick={closeAllMenus}>Contact Us</Link></li>
  <li><Link to="/faqs" className="chavo-navbar-link" onClick={closeAllMenus}>FAQ</Link></li>

  {!isLoggedIn && (
    <li className="auth-buttons">
      <Link to="/signin">
        <button className="navbar-btn-login" onClick={closeAllMenus}><FaUser className="icon" />Login</button>
      </Link>
      <Link to="/signup">
        <button className="navbar-btn-login" onClick={closeAllMenus}><FaUser className="icon" />Register</button>
      </Link>
    </li>
  )}

  {isLoggedIn && (
    <li className="user-menu-container" ref={dropdownRef}>
      <button className="user-icon" onClick={toggleProfileDropdown}>
        <FaUserCircle size={24} /> <FaCaretDown size={16} />
      </button>
      {showDropdown && (
        <ul className="user-dropdown">
          <li>
            <Link to="/userprofile" onClick={() => setShowDropdown(false)}>
              <FontAwesomeIcon icon={faUser} className="me-2" /> My Profile
            </Link>
          </li>
          <li>
            <Link to="/view-my-bookings" onClick={() => setShowDropdown(false)}>
              <FontAwesomeIcon icon={faFile} className="me-2" /> View My Bookings
            </Link>
          </li>
          <li>
            <Link to="/promotions" onClick={() => setShowDropdown(false)}>
              <FontAwesomeIcon icon={faFile} className="me-2" /> Promotions
            </Link>
          </li>
          <li>
            <button
              onClick={(e) => {
                handleLogout();
                setShowDropdown(false);
              }}
            >
              <FontAwesomeIcon icon={faSignOutAlt} className="me-2" /> Log Out
            </button>
          </li>
        </ul>
      )}
    </li>
  )}
</ul>







      </div>
    </nav>
  );
}

export default NavComp;
